'use client'

import { qrUriAtom } from 'features/generator/generatorState'
import { useHydrateAtoms } from 'jotai/utils'

import {
	plainTextContentAtom,
	TPlainTextContent,
} from './PlainTextContentState'
import { PlainTextScreen } from './PlainTextScreen'

export const PlainTextLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TPlainTextContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[plainTextContentAtom, content],
	])
	return <PlainTextScreen demoMode={false} previewMode={false} />
}
